import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import TermsPage from "../pages/terms/page";
import PrivacyPage from "../pages/privacy/page";
import CommercialLawPage from "../pages/commercial-law/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/terms",
    element: <TermsPage />,
  },
  {
    path: "/privacy",
    element: <PrivacyPage />,
  },
  {
    path: "/commercial-law",
    element: <CommercialLawPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;